var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumb"}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"d-inline-flex"},[_vm._t("actions")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }